var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon icon-tabler icon-tabler-dots",
    fill: "none",
    height: 24,
    stroke: "#5d5d5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none",
    stroke: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.11cb3156e220c53117d77120713fb6cf.svg";
export { ForwardRef as ReactComponent };